import { h } from "@stencil/core";
import { ReportItem } from "./report-row";
function getGroupedDocuments(documents) {
    return ((documents === null || documents === void 0 ? void 0 : documents.reduce((acc, doc) => {
        const key = doc.mission.assignmentType;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(doc);
        return acc;
    }, {})) || {});
}
export const GroupedReports = ({ t, documents, filteredDocuments, isOnMachinePage, machineNumber, machineAlias, machineName, technicianName }) => {
    if (!documents || !filteredDocuments) {
        return null;
    }
    if (documents.length === 0) {
        return h("div", { class: "ux-u-text-align--center ux-text-normal" }, t("mf-service-calls:serviceReports.noReportsAvailable"));
    }
    if (filteredDocuments.length === 0) {
        return h("div", { class: "ux-u-text-align--center ux-text-normal" }, t("mf-service-calls:serviceReports.noReportsFound"));
    }
    const groupedDocuments = getGroupedDocuments(filteredDocuments);
    if (!isOnMachinePage) {
        return (h("div", null, filteredDocuments.map((doc) => (h(ReportItem, { t: t, document: doc, machineNumber: machineNumber, machineAlias: machineAlias, machineName: machineName, technicianName: technicianName })))));
    }
    return (h("div", null, Object.keys(groupedDocuments).map((missionType, i) => {
        const amount = groupedDocuments[missionType].length;
        return (h("ux-accordion", { key: missionType, isExpanded: i === 0 }, h("span", { slot: "title", class: "ux-text-title ux-text-title--light" }, t(`mf-service-calls:serviceReports.reportTypesPlural.${missionType}`), " (", amount, ")"), h("mf-service-reports-paginated-items", { t: t, items: groupedDocuments[missionType], isOnMachinePage: true })));
    })));
};
//# sourceMappingURL=grouped-reports.js.map
